<script>

    import t from '../../translations/translator.js';
    import TextField from "../controls/TextField.svelte";
    import TextFieldPassword from "../controls/TextFieldPassword.svelte";
    import ButtonDefault from "../controls/ButtonDefault.svelte";
    import {userId, isLoggedIn} from "../stores/UserStore.js";
  
    export let onNavigateToRegister;
    export let onLogin;

    let emailTextField;
    let pwTextField;
    let errorMessage = "";
  
    async function handleLogin(event) {
        event.preventDefault();

        const email = emailTextField.value;
        const password = pwTextField.value;

        if (!email || !password) {
            errorMessage = t('General.msg.error.not_all_required_fields_are_set'); 
            return;
        }

        errorMessage = "";

        try {
            const response = await fetch("https://www.deckblox.app/rest/login", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email, password }),
                credentials: "include" 
            });

            const text = await response.text();
			let data; 
			try {
				data = JSON.parse(text);
			} catch (parseError) {
				errorMessage = t("Login.msg.error.something_went_wrong", 6001);
				return;
			}
			if (!response.ok) {
				errorMessage = data.message
					? `${data.message} (Error ${response.status}) (Raw: ${text})`
					: `Login failed with status ${response.status}`;
				return;
			}

            localStorage.setItem("csrfToken", data.csrf_token);
            isLoggedIn.set(true);
            userId.set(data.userId);

            onLogin();
        } catch (error) {
            errorMessage = t("Login.msg.error.something_went_wrong", 6002);
            //errorMessage = "Failed to login. Please try again.";
        }


    }
  </script>
  
  <div class="flex flex-grow items-center justify-center bg-[var(--app-background-color)]"> 
    <form class="w-full max-w-sm bg-[var(--app-background-level-2)] p-6 rounded-lg shadow-md -translate-y-20" on:submit={handleLogin}>
      <h2 class="text-xl font-bold mb-4 text-white">Login</h2>
  
        <!-- Email Field -->
        <div class="mb-4">
            <TextField
                placeholder={t("Enter your email")}
                label={t("Email")}
                bind:this={emailTextField}
            />
        </div>
  
      <!-- Password Field -->
        <div class="mb-4">
            <TextFieldPassword
                placeholder={t("Enter your password")}
                label={t("Password")}
                bind:this={pwTextField}
            />
        </div>

        {#if errorMessage}
            <p class="text-sm text-red-500">{errorMessage}</p>
        {/if}
  
        <!-- Submit Button -->
        <div class="mt-4">
            <ButtonDefault
            text={t("Login")}
            isEnabled={true}
            on:click={handleLogin}
            />
        </div>

        <div class="mt-2 text-center">
            <a href="/forgot-password" class="text-sm hover:underline text-gray-500">{t("forgotPassword")}</a>
        </div>

        <div class="mt-4 text-center">
			<button class="text-sm text-gray-500 hover:underline border border-transparent" on:click={onNavigateToRegister}>
				{t("create_new_account")}
			</button>
		</div>

    </form>
  </div>
  